import { render, staticRenderFns } from "./Cates.vue?vue&type=template&id=3825a91e&scoped=true&"
import script from "./Cates.vue?vue&type=script&lang=js&"
export * from "./Cates.vue?vue&type=script&lang=js&"
import style0 from "./Cates.vue?vue&type=style&index=0&id=3825a91e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3825a91e",
  null
  
)

export default component.exports